import { render, staticRenderFns } from "./Level2.vue?vue&type=template&id=2e14a2ee&"
import script from "./Level2.vue?vue&type=script&lang=js&"
export * from "./Level2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports